export default __webpack_public_path__ + "static/media/international-b.5123d4f9.png";